import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { noticeConfig } from "@/api/php/home";
import { ToBack } from "@/uitls/native";
import { useRouter } from "vue-router";
import { onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'AnnMaintain',
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const SVIP_ICON = require(`@/assets/${process.env.VUE_APP_NAME}/aboutLogo.png`);
const maitin = require(`@/assets/images/maitin.png`);
const maitain = require(`@/assets/${process.env.VUE_APP_NAME}/maitain.png`);
const appName = process.env.VUE_APP_TITLE as string;
const annnotice = ref('');
const intervaltime = ref();

onMounted(() => {
    config();
    ann();
});

onUnmounted(() => {
    if (intervaltime.value) {
        clearInterval(intervaltime.value);
    }
})

const ann = () => {
    intervaltime.value = setInterval(() => {
        config();
    }, 60 * 1000);
}

const config = async () => {
    let res: any = await noticeConfig();
    if (res.code == 200) {
        if (res.data.notice_open == 3) {
            annnotice.value = res.data.notice_content;
        } else {
            ToBack(router);
        }
    }
}



const __returned__ = { router, SVIP_ICON, maitin, maitain, appName, annnotice, intervaltime, ann, config }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})